import React, { useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from 'react-router-dom';






import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";


function Help(props) {

    const { token } = props;





    const [activeAccordion, setActiveAccordion] = useState(2);

    const toggleAccordion = (index) => {
        setActiveAccordion(activeAccordion === index ? null : index);
    };



    return token ? (
        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full">
                <Sidebar className="fixed top-0 left-0 h-screen pt-[64px] z-0" />
                <div id="dashboard-content" className="flex flex-col w-full p-4 overflow-auto">
                    <div className="accordion" id="faqAccordion">
                        {[
                            { question: "How do I create an account?", answer: "To create an account, click on the 'Sign Up' button on the homepage and fill in the required information." },
                            { question: "How do I reset my password?", answer: "To reset your password, click on 'Forgot Password?' on the login page and follow the instructions sent to your email." },
                            { question: "How do I contact support?", answer: "You can contact support by clicking on the 'Help' button in the top navigation bar and filling out the contact form." },
                            { question: "How do I update my profile?", answer: "To update your profile, go to the 'Profile' section from the sidebar and edit your information as needed." },
                            { question: "How do I log out?", answer: "To log out, click on your profile icon in the top right corner and select 'Logout' from the dropdown menu." }
                        ].map((item, index) => (
                            <div className="accordion-item border-b border-gray-200" key={index}>
                                <h2 className="accordion-header" id={`heading${index}`}>
                                    <button
                                        className={`accordion-button w-full text-left py-4 px-6 bg-gray-100 hover:bg-gray-200 focus:outline-none ${activeAccordion === index ? 'text-[#3b3b3b]' : 'text-gray-800'}`}
                                        type="button"
                                        onClick={() => toggleAccordion(index)}
                                        aria-expanded={activeAccordion === index}
                                        aria-controls={`collapse${index}`}
                                    >
                                        {item.question}
                                    </button>
                                </h2>
                                <div
                                    id={`collapse${index}`}
                                    className={`accordion-collapse ${activeAccordion === index ? 'block' : 'hidden'} bg-white px-6 py-4`}
                                    aria-labelledby={`heading${index}`}
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body text-gray-700">
                                        {item.answer}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,



    };
};

const mapDispatchToProps = (dispatch) => {
    return {


    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Help);
